import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';

export const HiddenRadioStyles = props => ({
  width: props.theme.isLargeRadioButton && '1.3em',
  height: props.theme.isLargeRadioButton && '1.3em',
  opacity: 0,
  position: 'absolute',
});

const useStyles = createUseStyles({
  radioBtn: {
    width: props => (props.theme.isLargeRadioButton ? '1.5em' : '1em'),
    height: props => (props.theme.isLargeRadioButton ? '1.5em' : '1em'),
    background: props => props.isSelected && 'radial-gradient(#2e47c2 45%, #fff 48%)',
    border: props => `1px solid ${props.isSelected ? '#2e47c2' : 'currentColor'}`,
    borderRadius: '50%',
    opacity: props => props.isDisabled && 0.5,
    transition: 'all 0.8s ease-out',
    outline: props => props.isFocused && `2px solid ${props.theme.core.brand}`,
  },
});

export default function RadioOverlay(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  return (
    <div className={classes.radioBtn} data-test={props.testName && `RadioOverlay--${props.testName}`} />
  );
}

RadioOverlay.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  isFocused: PropTypes.bool.isRequired,
  testName: PropTypes.string,
};

RadioOverlay.defaultProps = {
  isDisabled: false,
  testName: '',
};
